// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__38rhc","label":"SetPasswdForm_label__25SvJ"};